import { render, staticRenderFns } from "./ProblemReporter.vue?vue&type=template&id=30f411d4&scoped=true&"
import script from "./ProblemReporter.vue?vue&type=script&lang=js&"
export * from "./ProblemReporter.vue?vue&type=script&lang=js&"
import style0 from "./ProblemReporter.vue?vue&type=style&index=0&id=30f411d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f411d4",
  null
  
)

component.options.__file = "ProblemReporter.vue"
export default component.exports